import { sanitizeSupportDiagnosticString } from './SupportDiagnosticBuffer';
export type SyncDiagnosticException = { name?: string; message?: string; code?: string; details?: string; hint?: string; cause?: SyncDiagnosticException };
export const serializeSyncDiagnosticException = (error: unknown, depth = 0, seen = new Set<unknown>()): SyncDiagnosticException => {
  const clean = (value: string) => sanitizeSupportDiagnosticString(value)
    .replace(/data:[^\s]+/gi, '[media]')
    .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[email]')
    .replace(/(https?:\/\/[^\s?]+)\?[^\s]*/gi, '$1?[redacted]').slice(0, 480);
  if (!error || typeof error !== 'object') return { message: clean(String(error)) };
  if (seen.has(error) || depth > 2) return { message: '[limited-cause]' };
  seen.add(error);
  const result: SyncDiagnosticException = {};
  for (const key of ['name', 'message', 'code', 'details', 'hint'] as const) {
    try { const value = (error as any)[key]; if (typeof value === 'string' || typeof value === 'number') result[key] = clean(String(value)); } catch { /* Getter desconhecido não interfere no sync. */ }
  }
  try { if ((error as any).cause !== undefined) result.cause = serializeSyncDiagnosticException((error as any).cause, depth + 1, seen); } catch { /* Causa inacessível. */ }
  return result;
};
